<template>
  <v-layout
    align-center
    wrap
  >
    <v-flex
      v-for="(item, index) in items"
      :key="index"
      xs12
      :class="[{ 'personal-form': completed[index] }]"
    >
      <v-layout>
        <v-flex
          class="mt-4 mr-2"
          :shrink="lgAndUp"
        >
          <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
        </v-flex>
        <v-flex>
          <v-layout wrap>
            <v-flex
              v-if="getCashReceiptsQuestions.chosen_source_details.hasOwnProperty('chosen_source')"
              lg4
              md12
              :class="[{ 'pr-3': $vuetify.breakpoint.lgAndUp }]"
            >
              <v-text-field
                :label="getCashReceiptsQuestions.chosen_source_details.chosen_source.label"
                :class="[{ 'pr-3': $vuetify.breakpoint.lgAndUp }]"
                :value="supportTitle(item)"
                disabled
                class="personal-input_disabled"
              />
            </v-flex>
            <v-flex
              v-if="getCashReceiptsQuestions.chosen_source_details.hasOwnProperty('members')"
              lg4
              md12
              :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
            >
              <v-select
                :key="createDataName('another_incomes_persons', item.chosenSource)"
                v-model="item.members"
                v-validate="{
                  required: getCashReceiptsQuestions.chosen_source_details.members.required
                }"
                multiple
                :label="getCashReceiptsQuestions.chosen_source_details.members.label"
                :items="representatives"
                item-value="id"
                item-text="firstName"
                :error-messages="
                  errors.collect(createDataName('another_incomes_persons', item.chosenSource))
                "
                :data-vv-as="$t('label.first_name')"
                :data-vv-name="createDataName('another_incomes_persons', item.chosenSource)"
                :required="getCashReceiptsQuestions.chosen_source_details.members.required"
                append-icon="expand_more"
                :disabled="readOnly"
                @blur="completePersonData(index, item.chosenSource)"
                @focus="falseComplete(index)"
              />
            </v-flex>
            <v-flex
              v-if="getCashReceiptsQuestions.chosen_source_details.hasOwnProperty('amount')"
              lg4
              md12
              :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
            >
              <v-layout align-center>
                <v-flex lg8>
                  <v-text-field
                    :key="createDataName('another_incomes_amount', item.chosenSource)"
                    v-model="item.amount"
                    v-validate="{
                      ...requiredMoney(
                        getCashReceiptsQuestions.chosen_source_details.amount.required
                      )
                    }"
                    :label="getCashReceiptsQuestions.chosen_source_details.amount.label"
                    :error-messages="
                      errors.collect(createDataName('another_incomes_amount', item.chosenSource))
                    "
                    :data-vv-as="$t('label.amount_on_medicine_short')"
                    :data-vv-name="createDataName('another_incomes_amount', item.chosenSource)"
                    :required="getCashReceiptsQuestions.chosen_source_details.amount.required"
                    :disabled="readOnly"
                    inputmode="decimal"
                    @keyup="emitNewValue"
                    @blur="completePersonData(index, item.chosenSource)"
                    @focus="falseComplete(index)"
                  />
                </v-flex>
                <v-flex
                  lg4
                  shrink
                  justify-center
                >
                  <v-subheader class="px-0 pt-1 ml-2">
                    {{ $t('label.amount_suffix') }}
                  </v-subheader>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="getCashReceiptsQuestions.chosen_source_details.hasOwnProperty('note')"
              xs12
              class="mt-3"
            >
              <v-textarea
                :key="createDataName('regular_field', item.chosenSource)"
                v-model="item.note"
                v-validate="{
                  ...regularLongText(getCashReceiptsQuestions.chosen_source_details.note.required)
                }"
                :label="getCashReceiptsQuestions.chosen_source_details.note.label"
                :error-messages="errors.collect(createDataName('regular_field', item.chosenSource))"
                :data-vv-as="$t('label.question')"
                :data-vv-name="createDataName('regular_field', item.chosenSource)"
                class="small"
                :required="getCashReceiptsQuestions.chosen_source_details.note.required"
                :disabled="readOnly"
                :rows="2"
                auto-grow
                @blur="completePersonData(index, item.chosenSource)"
                @focus="falseComplete(index)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider class="my-3" />
    </v-flex>
  </v-layout>
</template>

<script>
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

import { mapGetters } from 'vuex';

export default {
    name: 'AnotherIncomes',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        items: {},
        selected: {},
        incomes: {},
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            completed: []
        };
    },
    computed: {
        ...mapGetters('sheet', ['getCashReceiptsQuestions']),
        lgAndUp () {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        representatives () {
            return this.$store.getters['sheet/getRepresentatives'];
        }
    },
    watch: {
        items: {
            handler (val) {
                val.forEach((el, index) => {
                    if (!this.completed[index]) {
                        this.completed.push(false);
                    }
                });
            },
            deep: true
        }
    },
    created () {
        this.items.forEach(() => {
            this.completed.push(false);
        });
    },
    methods: {
        emitNewValue () {
            this.$emit('emitCheck');
        },
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        supportTitle (item) {
            return this.incomes.find((e) => {
                return e.id === item.chosenSource;
            }).description;
        },
        completePersonData (i, source) {
            this.items.forEach((el, index) => {
                if (index === i) {
                    const _keys = [];
                    Object.keys(this.fields).forEach((key) => {
                        if (key.indexOf(source) !== -1) {
                            _keys.push(this.fields[key]);
                        }
                    });
                    this.completed[index] = Object.keys(_keys).every((key) => _keys[key].valid);
                }
            });
        },
        falseComplete (index) {
            this.completed[index] = false;
        }
    }
};
</script>

<style scoped></style>
